import { render } from "./App.vue?vue&type=template&id=129ac9d8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=129ac9d8&lang=less"

import exportComponent from "C:\\Users\\jialong_li\\Downloads\\cook-start-time-calculator (1)\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__